import AppLayout from './app-layout';
import MainPage from './pages/mainPage';
import Login from './pages/login';
import SignUp from './pages/signUp';
import Policy from './pages/policy';
import Notice from './pages/notice';
import Inquiry from './pages/inquiry';
import SettlementReport from './pages/settlementReport';
import PeriodReport from './pages/periodReport';
import FindPw from './pages/findPw';
import FindId from './pages/findId';
import Withdraw from './pages/withdraw';
import Payment from './pages/payment';

const routes = [
    {
        path: '/',
        element: <AppLayout/>,
        children: [
            {
                path: '',
                element: <MainPage/>,
            },
            {
                path: 'login',
                element: <Login/>,
            },
            {
                path: 'signUp',
                element: <SignUp/>,
            },
            {
                path: 'policy',
                element: <Policy/>,
            },
            {
                path: 'notice',
                element: <Notice/>,
            },
            {
                path: 'inquiry',
                element: <Inquiry/>,
            },
            {
                path: 'settlement-report',
                element: <SettlementReport/>,
            },
            {
                path: 'period-report',
                element: <PeriodReport/>,
            },
            {
                path: 'find-pw',
                element: <FindPw/>,
            },
            {
                path: 'find-id',
                element: <FindId/>,
            },
            {
                path: 'withdraw',
                element: <Withdraw/>,
            },
            {
                path: 'payment',
                element: <Payment/>,
            },
        ],
    },


];

export {routes};